import React, { useEffect, useState, useCallback } from "react";
import Slider from "react-slick";
import publicAxios from "../../../utils/publicAxios";
import Headerweb from "../../../components/layout/header/Headerweb";
import PhoneInput from "react-phone-input-2";
import {
  commonErrMsg,
  login,
  passwordtext,
  processing,
  profiletexts,
  refferalPartnerURL,
  reffPartner,
  signup
} from "../../../locales/en";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEye, FaEyeSlash, FaCheck, FaInfoCircle } from "react-icons/fa";
import "./refferalPageUrl.scss";
import "react-phone-input-2/lib/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//image URL
import fundTapImg from "./../../../assets/images/logo.png";
import invoicefinanceoffice from "../../../assets/images/refferalPartnerUrlimg/02_invoice-finance-office.webp";
import ratingStar from "../../../assets/images/refferalPartnerUrlimg/03_star.svg";
import gogleLogo from "../../../assets/images/refferalPartnerUrlimg/04_google.svg";
import xeroLogo from "../../../assets/images/refferalPartnerUrlimg/05_xero.svg";
import GlassforceBnr from "../../../assets/images/refferalPartnerUrlimg/06_Glassforce-210x210.jpg";
import GrafficBnr from "../../../assets/images/refferalPartnerUrlimg/07_Graffic-G-Logo-Gray-210x210.webp";
import stuartBnr from "../../../assets/images/refferalPartnerUrlimg/08_stuart_w-210x210.jpg";
import graymbnr from "../../../assets/images/refferalPartnerUrlimg/09_1605101044685-210x179.jpg";
import glennD from "../../../assets/images/refferalPartnerUrlimg/10_e3-210x158.jpg";
import sarahBnr from "../../../assets/images/refferalPartnerUrlimg/11_sarah-210x210.jpg";
import timeLogo from "../../../assets/images/refferalPartnerUrlimg/13_time.svg";
import rocketLogo from "../../../assets/images/refferalPartnerUrlimg/14_rocket.svg";
import accountLogo from "../../../assets/images/refferalPartnerUrlimg/15_account.svg";
import waveLogo from "../../../assets/images/refferalPartnerUrlimg/16_wave.svg";
import laptopimg from "../../../assets/images/refferalPartnerUrlimg/17_laptop.webp";
import leftCurve from "../../../assets/images/refferalPartnerUrlimg/18_left-curve.svg";
import webview from "../../../assets/images/refferalPartnerUrlimg/19_web-view.webp";
import mobileView from "../../../assets/images/refferalPartnerUrlimg/20_mobile.webp";
import rightCurve from "../../../assets/images/refferalPartnerUrlimg/21_right-curve.svg";
import xeroicon from "../../../assets/images/refferalPartnerUrlimg/22_xero-logo.svg";
import myObicon from "../../../assets/images/refferalPartnerUrlimg/23_myob.webp";
import daddyicon from "../../../assets/images/refferalPartnerUrlimg/24_daddy-logo.svg";
import reckonicon from "../../../assets/images/refferalPartnerUrlimg/26_reckon-logo.svg";
import intuitQuickbooks from "../../../assets/images/refferalPartnerUrlimg/27_intuit-quickbooks.svg";
import tickMark from "../../../assets/images/refferalPartnerUrlimg/28_tick-mark.svg";
import crossMark from "../../../assets/images/refferalPartnerUrlimg/29_cross.svg";
import { referralPartnerImageThunk } from "../../../redux/referraPartnerSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  showToast,
  isValidPhoneLength,
  countryMap,
  isRecaptchaEnabled
} from "../../../utils/utils";
import {
  AU_PHONE_REGEX,
  COUNTRY_CODE_AU_SMALL,
  COUNTRY_CODE_NZ,
  COUNTRY_CODE_NZ_SMALL,
  DIGIT_REGEX,
  EMAIL_REGEX_SIMPLE,
  ESCAPE_REGEX,
  EXPIRY_ERROR,
  IP_API_URL,
  NAME_REGEX,
  NZ_PHONE_REGEX,
  RECAPTCHA_ERROR,
  showToastType,
  UPPERCASE_REGEX,
  WHITESPACE_REGEX
} from "../../../utils/constants/appConstants";
import useMixpanelEventAction from "../../../config/mixpanel/useMixpanelEventAction";
import GA4EventAction from "../../../config/GoogleAnalytics/useGA4EventAction";
import {
  getFetchCountryCodeURL,
  getRegisterUrl
} from "../../../utils/constants/apiEndPoints";
import { DEMO_ACCOUNT_INVOICES, INVOICE } from "../../../route/paths";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  buildMarketingIdentifiers,
  clearStoredAdClickIds
} from "../../../utils/marketingIdentifiers";

export default function RefferalPartnerURLPage() {
  const environment = process.env.REACT_APP_ENV;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [imageBase64, setImageBase64] = useState("");
  const [fileType, setFileType] = useState("");
  const [description, setDescription] = useState("");
  const [validatePhnumber, setValidatePhnumber] = useState(false);
  const { referralCode } = useParams();
  const { signupMixpanelEvent } = useMixpanelEventAction();
  const { signupGA4Event } = GA4EventAction();
  const { referralPartnerPageLoad } = useSelector(
    (state) => state.referralPartner
  );
  const initialLoading = {
    signUpBtn: false
  };
  const [loading, setLoading] = useState(initialLoading);
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    showPassword: false,
    error: ""
  };
  const initialErrors = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    recaptcha: "",
    submit: ""
  };
  const initialCountry = COUNTRY_CODE_AU_SMALL;

  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialErrors);
  const [country, setCountry] = useState(initialCountry);
  const [selectCountry, setSelectCountry] = useState(initialCountry);

  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1
  };

  const imageDisplay = async (referralCode) => {
    try {
      const response = await dispatch(
        referralPartnerImageThunk(referralCode)
      ).unwrap();

      const base64String = response.data.data.image;
      const fileTypeString = response.data.data.fileType;
      const description = response.data.data.partnerListingDescription;

      setImageBase64(base64String);
      setFileType(fileTypeString);
      setDescription(description);
    } catch {
      // handle catch here;
    }
  };

  const handleInputChange = (field, value) => {
    setValues({ ...values, [field]: value });
  };

  const fetchCountryCode = useCallback(async (phoneNumber, country) => {
    try {
      const response = await publicAxios.get(getFetchCountryCodeURL, {
        params: { number: phoneNumber, countryCode: country }
      });
      if (response.status === 200) {
        setValidatePhnumber(true);
      } else {
        setValidatePhnumber(false);
      }
    } catch {
      setValidatePhnumber(false);
    }
  }, []);

  const selectedCountry = (phoneNumber) => {
    const countryCode = phoneNumber.slice(0, 2);
    return countryMap[countryCode] || null;
  };

  const requestPhoneNumber = (phoneNumnber) => {
    const result = phoneNumnber.slice(2).replace(/[()-\s]/g, "");
    return result;
  };

  const handlePhInputChange = (field, value, countryCode) => {
    setValues({ ...values, [field]: value });
    setValidatePhnumber(false);

    if (selectCountry !== countryCode) {
      const result = validateField(field, value);
      if (result !== "") return;
      const phoneNumber = requestPhoneNumber(value);
      fetchCountryCode(phoneNumber, selectedCountry(value));
    }
  };

  const handleBlur = (field, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [field]: value
    }));
    // Trigger validation for the specific field
    const result = validateField(field, value);
    if (result !== "") return;
    const phoneNumber = requestPhoneNumber(values.phoneNumber);
    if (phoneNumber && phoneNumber !== value) {
      fetchCountryCode(phoneNumber, selectedCountry(value));
    }
  };

  const validateField = (field, value) => {
    let error = "";
    switch (field) {
      case "firstName":
        if (value.trim().length === 0) {
          error = profiletexts?.errorMessage.firstNameRequired;
        } else if (!NAME_REGEX.test(value)) {
          error = signup?.errors.firstnameErr;
        } else if (value.trim().length < 2) {
          error = profiletexts?.errorMessage.firstNameError;
        }
        break;
      case "lastName":
        if (value.trim().length === 0) {
          error = profiletexts?.errorMessage.lastNameRequired;
        } else if (!NAME_REGEX.test(value)) {
          error = signup?.errors.lastnameErr;
        } else if (value.trim().length < 2) {
          error = profiletexts?.errorMessage.lastNameError;
        }
        break;
      case "email":
        error = EMAIL_REGEX_SIMPLE.test(value)
          ? ""
          : login?.errorMSG.enterEmail;
        break;
      case "phoneNumber": {
        const trimmedValue = value.replace(WHITESPACE_REGEX, "");
        const numericValue = value.trim().replace(/[^\d]/g, "");

        if (
          AU_PHONE_REGEX.test(trimmedValue) ||
          NZ_PHONE_REGEX.test(trimmedValue)
        ) {
          error = signup?.errors.startnumber;
        } else if (trimmedValue === "61" || trimmedValue === "64") {
          error = signup?.numberRequired;
        } else if (!isValidPhoneLength(numericValue)) {
          error = profiletexts?.errorMessage.primaryContactError;
        }
        break;
      }
      case "password":
        if (!value || value.trim().length === 0) {
          error = signup?.errors.passRequired;
        } else {
          const passwordErrors = [];
          if (value.length < 8) {
            passwordErrors.push(
              <small key="length" className="mt-1 d-block">
                <FaInfoCircle /> {signup?.passValidation.rule1}
              </small>
            );
          }
          if (!DIGIT_REGEX.test(value)) {
            passwordErrors.push(
              <small key="digit" className="mt-1 d-block">
                <FaInfoCircle /> {signup?.passValidation.rule2}
              </small>
            );
          }
          if (!UPPERCASE_REGEX.test(value)) {
            passwordErrors.push(
              <small key="uppercase" className="mt-1 d-block">
                <FaInfoCircle /> {signup?.passValidation.rule3}
              </small>
            );
          }
          if (!ESCAPE_REGEX.test(value)) {
            passwordErrors.push(
              <small key="special" className="mt-1 d-block">
                <FaInfoCircle /> {signup?.passValidation.rule4}
              </small>
            );
          }
          error =
            passwordErrors.length > 0 ? (
              <>
                {passwordErrors.map((item, index) => (
                  <React.Fragment key={index}>{item}</React.Fragment>
                ))}
              </>
            ) : (
              <small className="primary-color">
                <FaCheck />
                {passwordtext?.okPassword}
              </small>
            );
        }
        break;
      default:
        break;
    }

    // Flatten the error message if it’s an array or object
    if (typeof error === "object" && !React.isValidElement(error)) {
      error = Object.values(error).flat().join(", ");
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: error
    }));

    return error;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const firstNameError = validateField("firstName", values.firstName);
    const lastNameError = validateField("lastName", values.lastName);
    const emailError = validateField("email", values.email);
    const phoneNumberError = validateField("phoneNumber", values.phoneNumber);
    const passwordError = validateField("password", values.password);
    const errors = {
      firstName: firstNameError,
      lastName: lastNameError,
      email: emailError,
      phoneNumber: phoneNumberError,
      password: passwordError,
      recaptcha: ""
    };

    setErrors(errors);

    // Check if any errors exist
    const hasErrors = Object.values(errors).some((error) => error.length > 0);
    if (hasErrors) {
      return;
    }

    let recaptchaToken = null;

    if (isRecaptchaEnabled(environment)) {
      if (!executeRecaptcha) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          recaptcha: commonErrMsg?.RecaptchaError
        }));
        return;
      }
      recaptchaToken = await executeRecaptcha("signup");
    }

    if (isRecaptchaEnabled(environment)) {
      if (!recaptchaToken) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          recaptcha: login?.errorMSG.recaptcha
        }));
        return;
      }
    }

    // Convert the phone number to E.164 format
    const e164PhoneNumber = `+${values.phoneNumber.replace(/\D/g, "")}`;

    try {
      const userdataentry = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        primaryContactNumber: e164PhoneNumber,
        password: values.password.trim(),
        recaptchaResponse: recaptchaToken,
        referralCode: referralCode || null,
        marketingIdentifiers: buildMarketingIdentifiers()
      };

      setLoading((prev) => ({ ...prev, signUpBtn: true }));
      const response = await publicAxios.post(getRegisterUrl, userdataentry);

      if (response.status === 200 || response.status === 201) {
        showToast(response.data.message, showToastType.success);
        // The registered account owns the ad click that was stored for it, so it is forgotten
        // here rather than credited again to whoever signs up next on this browser.
        clearStoredAdClickIds();
        signupMixpanelEvent(response?.data?.data);
        signupGA4Event(response?.data?.data, referralCode);
        navigate(INVOICE);
      } else {
        setErrors({ ...errors, submit: response.data.errors });
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          const { message, errors } = error.response.data;
          if (message !== "Validation failed") {
            const errorMessages = Object.values(errors)
              .flatMap((fieldErrors) => {
                if (Array.isArray(fieldErrors)) {
                  return fieldErrors.flat();
                } else if (
                  typeof fieldErrors === "object" &&
                  fieldErrors !== null
                ) {
                  return Object.values(fieldErrors).flat();
                }
                return String(fieldErrors);
              })
              .join("\n");
            showToast(errorMessages, showToastType.error);
          }
        } else if (error.response.status === 403) {
          setErrors({ ...errors, submit: error.response.data.message });
        } else if (
          error.response.status === 409 ||
          error.response.status === 500
        ) {
          setErrors({ ...errors, submit: error.response.data.errors });
        } else if (error.response.status === 406) {
          const apiErrors = error.response.data.errors || [];

          if (apiErrors.some((err) => err.includes(RECAPTCHA_ERROR))) {
            setErrors((prev) => ({
              ...prev,
              submit: error.response.data.errors[0]
            }));
            return;
          }

          if (apiErrors.some((err) => err.includes(EXPIRY_ERROR))) {
            setErrors((prev) => ({
              ...prev,
              submit: error.response.data.message
            }));
            return;
          }
        } else {
          setErrors({ ...errors, submit: error.response.data.message });
        }
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          submit: login?.errorMSG.somethingWrong
        }));
      }
    } finally {
      setLoading((prev) => ({ ...prev, signUpBtn: false }));
    }
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch(IP_API_URL);
        const data = await response.json();
        if (data.country_code === COUNTRY_CODE_NZ) {
          setCountry(COUNTRY_CODE_NZ_SMALL);
        } else {
          setCountry(COUNTRY_CODE_AU_SMALL);
        }
      } catch {
        // handle catch here;
      }
    };
    fetchUserLocation();
  }, [country]);

  useEffect(() => {
    if (referralCode) {
      imageDisplay(referralCode);
    }
  }, [referralCode]);

  if (referralPartnerPageLoad) {
    return (
      <div className="spinner-wrap bg-light full-height">
        <div className="spinner-border custom-spinner-color" />
      </div>
    );
  }

  return (
    <>
      <Headerweb />

      <div className="refrral-banner-section">
        <div className="container-wrap">
          <div className="row">
            <div className="col-md-7">
              <div className="referral-benner-logos">
                <ul>
                  <li>
                    <img src={fundTapImg} alt="logo" width="458" height="101" />
                  </li>
                  <li>&amp;</li>
                  <li>
                    {imageBase64 && (
                      <img
                        className="transparent-bg"
                        src={`data:image/${fileType};base64,${imageBase64}`}
                        alt="Referral Partner Logo"
                      />
                    )}
                  </li>
                </ul>
              </div>
              <div className="banner-title-area">
                <h1>
                  {`${refferalPartnerURL.bannerSection.heading} `}
                  <span>{refferalPartnerURL.bannerSection.sub1}</span>
                  {refferalPartnerURL.bannerSection.sub2}
                </h1>
                <ul className="direction-btn">
                  <li>
                    <Link
                      to="#get-started"
                      className="btn btn-primary radius-50"
                    >
                      {refferalPartnerURL.bannerSection.content}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-5 referral-banner-img">
              <div className="banner-img">
                <img
                  src={invoicefinanceoffice}
                  alt="banner-img"
                  width="370"
                  height="276"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="shape_ellipse" />
        <div className="shape_round" />
      </div>

      {(description || imageBase64) && (
        <div className="cta-section">
          <div className="container-wrap">
            <div className="row">
              <div className="col-md-7">
                {description && (
                  <div className="main-cta-content">
                    <h2>{description}</h2>
                  </div>
                )}
              </div>
              <div className="col-md-5">
                {imageBase64 && (
                  <div className="main-cta-img">
                    <img
                      className="transparent-bg"
                      src={`data:image/${fileType};base64,${imageBase64}`}
                      alt="Referral Partner Logo"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div id="get-started" className="marginTop signinup-wrap-section">
        <div className="account signinuppart">
          <div className="container-wrap">
            <div className="info-enter-sec">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="signup-left-content">
                    <div className="client-comment-wrap">
                      <p className="comment-text pe-3 mb-4">
                        <i>{reffPartner?.partnerSignup?.para1}</i>
                      </p>
                      <p className="clienT-namE">
                        {refferalPartnerURL.signupWrapSection.p1}
                      </p>
                      <p className="clienT-Des">
                        {refferalPartnerURL.signupWrapSection.p2}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="signinuppartholder right-padding-0">
                    <div className="signup-heading clearfix">
                      <h2 className="heading_text-content">
                        {`${refferalPartnerURL.signupWrapSection.sub1} `}
                        <strong>
                          {`${refferalPartnerURL.signupWrapSection.sub2} `}
                        </strong>
                        {refferalPartnerURL.signupWrapSection.sub3}
                      </h2>
                      <p> {refferalPartnerURL.signupWrapSection.p3}</p>
                    </div>
                    <div className="row signup-form">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            id="first_name"
                            type="text"
                            placeholder="First Name"
                            name="first_name"
                            onChange={(e) =>
                              handleInputChange("firstName", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("firstName", e.target.value)
                            }
                            value={values.firstName}
                            autoComplete="true"
                          />
                          {errors.firstName && (
                            <p className="error-message text-danger">
                              <small>{errors.firstName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            id="last_name"
                            type="text"
                            placeholder="Doe"
                            name="last_name"
                            onChange={(e) =>
                              handleInputChange("lastName", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("lastName", e.target.value)
                            }
                            value={values.lastName}
                            autoComplete="true"
                          />
                          {errors.lastName && (
                            <p className="error-message text-danger">
                              <small>{errors.lastName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            id="email"
                            type="email"
                            placeholder="alexandoe@example.com"
                            name="email"
                            onChange={(e) =>
                              handleInputChange("email", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("email", e.target.value)
                            }
                            value={values.email}
                            autoComplete="true"
                          />
                          {errors.email && (
                            <p className="error-message text-danger">
                              <small>{errors.email}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <PhoneInput
                            inputProps={{
                              name: "phone_number",
                              id: "phone_number"
                            }}
                            className="ph-with-country-code"
                            country={country}
                            value={values.phoneNumber}
                            countryCodeEditable={false}
                            onlyCountries={["nz", "au"]}
                            areaCodes={{ au: ["61"], nz: ["64"] }}
                            masks={{
                              au: "(..) .... ...",
                              nz: "(..) .... ...."
                            }}
                            onChange={(value, event) => {
                              setSelectCountry(event.countryCode);
                              handlePhInputChange(
                                "phoneNumber",
                                value,
                                event.countryCode
                              );
                            }}
                            onBlur={() =>
                              handleBlur("phoneNumber", values.phoneNumber)
                            }
                          />
                          {validatePhnumber && (
                            <p className="error-message">
                              <small className="primary-color">
                                <small>
                                  <FaCheck /> {signup?.signupBox.phoneOkay}
                                </small>
                              </small>
                            </p>
                          )}
                          {errors.phoneNumber && (
                            <p className="error-message text-danger">
                              <small>{errors.phoneNumber}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="passowrd-show">
                            <input
                              id="password"
                              name="password"
                              type={values.showPassword ? "text" : "password"}
                              onChange={(e) =>
                                handleInputChange("password", e.target.value)
                              }
                              onBlur={(e) =>
                                validateField("password", e.target.value)
                              }
                              value={values.password}
                              placeholder="at least 8 characters"
                              autoComplete="false"
                            />
                            <button
                              type="button"
                              className="password-icon"
                              onClick={handleClickShowPassword}
                            >
                              {values.showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                          {errors.password && (
                            <p className="error-message text-danger">
                              <small>{errors.password}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <button
                            type="submit"
                            className="btn btn-primary hoverStroke"
                            onClick={handleSubmit}
                            disabled={loading.signUpBtn}
                          >
                            {loading.signUpBtn
                              ? processing
                              : signup?.getFundingBtn}
                          </button>
                          <p className="signupForm-info">
                            {refferalPartnerURL.signupWrapSection.p4}
                          </p>
                        </div>
                        {errors.submit && (
                          <small className="text-danger mt-2">
                            {errors.submit}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="customer-testimonial">
        <div className="container-wrap">
          <div className="row">
            <div className="col-md-12">
              <div className="customer-title headline-title">
                <h2> {refferalPartnerURL.customerTestimonial.heading}</h2>
              </div>
              <div className="customer-ratting">
                <Link to="#">
                  <div>
                    <img src={ratingStar} alt="star" width="201" height="40" />
                  </div>
                  <div>
                    <img src={gogleLogo} alt="google" width="72" height="23" />
                  </div>
                </Link>
                <Link to="#">
                  <div>
                    <img src={ratingStar} alt="star" width="201" height="40" />
                  </div>
                  <div>
                    <img src={xeroLogo} alt="xero" width="51" height="15" />
                  </div>
                </Link>
              </div>
            </div>
            <div className="col-md-12">
              <div className="customer-ratting-slider">
                <Slider {...settings}>
                  <div>
                    <div className="ratting-slider-item">
                      <div className="review-blog">
                        <div className="client-details">
                          <div className="client-img">
                            <img
                              width="210"
                              height="210"
                              src={GlassforceBnr}
                              className="attachment-profile-image size-profile-image"
                              alt=""
                            />
                          </div>
                          <div className="client-title">
                            <h4>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial1.heading
                              }
                            </h4>
                            <p>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial1.company
                              }
                            </p>
                          </div>
                        </div>
                        <div className="about-content">
                          <p>
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial1.content
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="ratting-slider-item">
                      <div className="review-blog">
                        <div className="client-details">
                          <div className="client-img">
                            <img
                              width="210"
                              height="210"
                              src={GrafficBnr}
                              className="attachment-profile-image size-profile-image"
                              alt=""
                            />
                          </div>
                          <div className="client-title">
                            <h4>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial2.heading
                              }
                            </h4>
                            <p>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial2.company
                              }
                            </p>
                          </div>
                        </div>
                        <div className="about-content">
                          <p>
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial2.content
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="ratting-slider-item">
                      <div className="review-blog">
                        <div className="client-details">
                          <div className="client-img">
                            <img
                              width="210"
                              height="210"
                              src={stuartBnr}
                              className="attachment-profile-image size-profile-image"
                              alt=""
                            />
                          </div>
                          <div className="client-title">
                            <h4>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial3.heading
                              }
                            </h4>
                            <p>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial3.company
                              }
                            </p>
                          </div>
                        </div>
                        <div className="about-content">
                          <p>
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial3.content
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="ratting-slider-item">
                      <div className="review-blog">
                        <div className="client-details">
                          <div className="client-img">
                            <img
                              width="210"
                              height="210"
                              src={graymbnr}
                              className="attachment-profile-image size-profile-image"
                              alt=""
                            />
                          </div>
                          <div className="client-title">
                            <h4>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial4.heading
                              }
                            </h4>
                            <p>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial4.company
                              }
                            </p>
                          </div>
                        </div>
                        <div className="about-content">
                          <p>
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial4.content
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="ratting-slider-item">
                      <div className="review-blog">
                        <div className="client-details">
                          <div className="client-img">
                            <img
                              width="210"
                              height="210"
                              src={glennD}
                              className="attachment-profile-image size-profile-image"
                              alt=""
                            />
                          </div>
                          <div className="client-title">
                            <h4>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial5.heading
                              }
                            </h4>
                            <p>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial5.company
                              }
                            </p>
                          </div>
                        </div>
                        <div className="about-content">
                          <p>
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial5.content
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="ratting-slider-item">
                      <div className="review-blog">
                        <div className="client-details">
                          <div className="client-img">
                            <img
                              width="210"
                              height="210"
                              src={GlassforceBnr}
                              className="attachment-profile-image size-profile-image"
                              alt=""
                            />
                          </div>
                          <div className="client-title">
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial6.heading
                            }
                            <h4 />
                            <p>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial6.company
                              }
                            </p>
                          </div>
                        </div>
                        <div className="about-content">
                          <p>
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial6.content
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="ratting-slider-item">
                      <div className="review-blog">
                        <div className="client-details">
                          <div className="client-img">
                            <img
                              width="210"
                              height="210"
                              src={sarahBnr}
                              className="attachment-profile-image size-profile-image"
                              alt=""
                            />
                          </div>
                          <div className="client-title">
                            <h4>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial7.heading
                              }
                            </h4>
                            <p>
                              {
                                refferalPartnerURL.customerTestimonial
                                  .testimonial7.company
                              }
                            </p>
                          </div>
                        </div>
                        <div className="about-content">
                          <p>
                            {
                              refferalPartnerURL.customerTestimonial
                                .testimonial7.content
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <div className="green-ellipse" />
      </div>

      <div className="why-choose-section">
        <div className="container-wrap">
          <div className="choose-us-container">
            <div className="row">
              <div className="col-md-24">
                <div className="choose-us-title headline-title">
                  <h2>
                    {`${refferalPartnerURL.whyChooseSection.heading} `}
                    <strong>
                      {refferalPartnerURL.whyChooseSection.headingBold}
                    </strong>
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="choose-blogs">
                  <div className="choose-icon">
                    <img
                      width="53"
                      height="52"
                      src={timeLogo}
                      className="attachment-full size-full"
                      alt="clock"
                    />
                  </div>
                  <h3>
                    {refferalPartnerURL.whyChooseSection.feature1.heading1}
                    <br />
                    {refferalPartnerURL.whyChooseSection.feature1.heading2}
                  </h3>
                  <p>{refferalPartnerURL.whyChooseSection.feature1.content}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="choose-blogs">
                  <div className="choose-icon">
                    <img
                      width="51"
                      height="50"
                      src={rocketLogo}
                      className="attachment-full size-full"
                      alt="rocket"
                      decoding="async"
                      loading="lazy"
                    />
                  </div>
                  <h3>
                    {refferalPartnerURL.whyChooseSection.feature2.heading}
                  </h3>
                  <p>{refferalPartnerURL.whyChooseSection.feature2.content}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="choose-blogs">
                  <div className="choose-icon">
                    <img
                      width="76"
                      height="75"
                      src={accountLogo}
                      className="attachment-full size-full"
                      alt="account"
                      decoding="async"
                      loading="lazy"
                    />
                  </div>
                  <h3>
                    {refferalPartnerURL.whyChooseSection.feature3.heading}
                  </h3>
                  <p>{refferalPartnerURL.whyChooseSection.feature3.content}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="work-section">
        <div className="container-wrap">
          <div className="row">
            <div className="col-md-24">
              <div className="work-section-title headline-title">
                <h2>
                  {refferalPartnerURL.workSection.heading}
                  <strong> {refferalPartnerURL.workSection.headingBold}</strong>
                </h2>
              </div>
            </div>
          </div>
          <div className="d-flex steps-wrap-row">
            <div className="steps-blog">
              <div className="steps-blog-content">
                <div className="step-box-wrap">
                  <div className="step-box">
                    <h3> {refferalPartnerURL.workSection.step1}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="steps-blog">
              <div className="steps-blog-content">
                <div className="step-box-wrap">
                  <div className="step-box">
                    <h3>{refferalPartnerURL.workSection.step2}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="steps-blog">
              <div className="steps-blog-content">
                <div className="step-box-wrap">
                  <div className="step-box">
                    <h3>{refferalPartnerURL.workSection.step3}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="steps-blog">
              <div className="steps-blog-content">
                <div className="step-box-wrap">
                  <div className="step-box">
                    <h3>{refferalPartnerURL.workSection.step4}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="wave">
              <img src={waveLogo} alt="wave" width="1223" height="245" />
            </div>
          </div>
          <svg
            width="0"
            height="0"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
          >
            <defs>
              <filter id="goo">
                <feGaussianBlur
                  in="SourceGraphic"
                  stdDeviation="8"
                  result="blur"
                />
                <feColorMatrix
                  in="blur"
                  mode="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                  result="goo"
                />
                <feComposite in="SourceGraphic" in2="goo" operator="atop" />
              </filter>
            </defs>
          </svg>
          <div className="row">
            <div className="col-md-24">
              <div className="view-demo-btn">
                <Link to={DEMO_ACCOUNT_INVOICES} className="secondary-btn">
                  {refferalPartnerURL.workSection.demoBtn}
                </Link>
              </div>
            </div>
          </div>
          <div className="working-stepviews">
            <ul className="working-img-view">
              <li>
                <img
                  width="448"
                  height="245"
                  src={laptopimg}
                  className="attachment-full size-full"
                  alt="laptop"
                />
                <div className="rotate-shape-left">
                  <img
                    src={leftCurve}
                    alt="left-curve"
                    width="75"
                    height="86"
                  />
                </div>
              </li>
              <li>
                <img
                  width="938"
                  height="569"
                  src={webview}
                  className="attachment-full size-full"
                  alt="web-view"
                />
              </li>
              <li>
                <img
                  width="149"
                  height="298"
                  src={mobileView}
                  className="attachment-full size-full"
                  alt="mobile"
                />
                <div className="rotate-shape-right">
                  <img
                    src={rightCurve}
                    alt="right-curve"
                    width="88"
                    height="73"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="green-ellipse" />
        <div className="yellow-round-2" />
      </div>

      <div className="partner-section-wrap">
        <div className="container-wrap">
          <div className="partner-container">
            <div className="row">
              <div className="col-md-24">
                <div className="partner-title headline-title">
                  <h2>{refferalPartnerURL.partnerSectionWrap.heading}</h2>
                  <p>{refferalPartnerURL.partnerSectionWrap.subHeading}</p>
                </div>
              </div>
            </div>
            <div className="partner-logo-wrap">
              <div className="partner-logo">
                <img
                  width="66"
                  height="66"
                  src={xeroicon}
                  className="attachment-full size-full"
                  alt="xero-logo"
                />
              </div>
              <div className="partner-logo">
                <img
                  width="200"
                  height="105"
                  src={myObicon}
                  className="attachment-full size-full"
                  alt=""
                />
              </div>
              <div className="partner-logo">
                <img
                  width="176"
                  height="57"
                  src={daddyicon}
                  className="attachment-full size-full"
                  alt="daddy-logo"
                />
              </div>
              <div className="partner-logo">
                <img
                  width="144"
                  height="42"
                  src={reckonicon}
                  className="attachment-full size-full"
                  alt="reckon-logo"
                />
              </div>
              <div className="partner-logo">
                <img
                  width="204"
                  height="56"
                  src={intuitQuickbooks}
                  className="attachment-full size-full"
                  alt="quickbooks"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="compare-section">
        <div className="container-wrap">
          <div className="compare-section-title headline-title">
            <h2>
              {refferalPartnerURL.compareSection.heading}
              <strong> {refferalPartnerURL.compareSection.headingBold}</strong>?
            </h2>
          </div>
          <div className="compare-chart">
            <nav className="table-tab">
              <ul>
                <li>
                  <Link to="#" className="active">
                    {refferalPartnerURL.compareSection.tab1}
                  </Link>
                </li>
                <li>
                  <Link to="#">{refferalPartnerURL.compareSection.tab2}</Link>
                </li>
                <li>
                  <Link to="#">{refferalPartnerURL.compareSection.tab3}</Link>
                </li>
              </ul>
            </nav>
            <table className="chart-list">
              <thead>
                <tr>
                  <th>
                    <strong />
                  </th>
                  <th>
                    <strong>
                      <div className="chart-head-logo">
                        <img
                          src={fundTapImg}
                          alt="logo"
                          width="458"
                          height="101"
                        />
                      </div>
                    </strong>
                  </th>
                  <th>
                    <strong>
                      {refferalPartnerURL.compareSection.tableHeader3}
                    </strong>
                  </th>
                  <th>
                    <strong>
                      {refferalPartnerURL.compareSection.tableHeader4}
                    </strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row1.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row2.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row3.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row4.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row4.fundTap}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row4.onlineInvoice}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row4.traditional}
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row5.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row5.fundTap}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row5.onlineInvoice}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row5.onlineInvoice}
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row6.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row7.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row8.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>
                      {refferalPartnerURL.compareSection.row9.feature}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={tickMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                  <td>
                    <strong>
                      <img
                        src={crossMark}
                        alt="tick-mark"
                        width="33"
                        height="33"
                      />
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="demo-btn">
              <Link
                to={DEMO_ACCOUNT_INVOICES}
                className="btn btn-primary radius-50"
              >
                {refferalPartnerURL.compareSection.demoBtn}
              </Link>
            </div>
          </div>
        </div>
        <div className="squer-shape-yellow" />
      </div>

      <div className="marginTop signinup-wrap-section">
        <div className="account signinuppart">
          <div className="container-wrap">
            <div className="info-enter-sec">
              <div className="row col-reverse">
                <div className="col-md-6">
                  <div className="signup-left-content">
                    <div className="client-comment-wrap">
                      <p className="comment-text pe-5 mb-4">
                        <i>{reffPartner?.partnerSignup?.para1}</i>
                      </p>
                      <p className="clienT-namE">
                        {refferalPartnerURL.signupWrapSection.p1}
                      </p>
                      <p className="clienT-Des">
                        {refferalPartnerURL.signupWrapSection.p2}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="signinuppartholder right-padding-0">
                    <div className="signup-heading clearfix">
                      <h2 className="heading_text-content">
                        {`${refferalPartnerURL.signupWrapSection.sub1} `}
                        <strong>
                          {`${refferalPartnerURL.signupWrapSection.sub2} `}
                        </strong>

                        {refferalPartnerURL.signupWrapSection.sub3}
                      </h2>
                      <p>{refferalPartnerURL.signupWrapSection.p3}</p>
                    </div>

                    <div className="row signup-form">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            id="first_name"
                            type="text"
                            placeholder="First Name"
                            name="first_name"
                            onChange={(e) =>
                              handleInputChange("firstName", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("firstName", e.target.value)
                            }
                            value={values.firstName}
                            autoComplete="true"
                          />
                          {errors.firstName && (
                            <p className="error-message text-danger">
                              <small>{errors.firstName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            id="last_name"
                            type="text"
                            placeholder="Doe"
                            name="last_name"
                            onChange={(e) =>
                              handleInputChange("lastName", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("lastName", e.target.value)
                            }
                            value={values.lastName}
                            autoComplete="true"
                          />
                          {errors.lastName && (
                            <p className="error-message text-danger">
                              <small>{errors.lastName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            id="email"
                            type="email"
                            placeholder="alexandoe@example.com"
                            name="email"
                            onChange={(e) =>
                              handleInputChange("email", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("email", e.target.value)
                            }
                            value={values.email}
                            autoComplete="true"
                          />
                          {errors.email && (
                            <p className="error-message text-danger">
                              <small>{errors.email}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <PhoneInput
                            inputProps={{
                              name: "phone_number",
                              id: "phone_number"
                            }}
                            className="ph-with-country-code"
                            country={country}
                            value={values.phoneNumber}
                            countryCodeEditable={false}
                            onlyCountries={["nz", "au"]}
                            areaCodes={{ au: ["61"], nz: ["64"] }}
                            masks={{ au: "(..) .... ...", nz: "(..) .... ..." }}
                            onChange={(value, event) => {
                              setSelectCountry(event.countryCode);
                              handlePhInputChange(
                                "phoneNumber",
                                value,
                                event.countryCode
                              );
                            }}
                            onBlur={() =>
                              handleBlur("phoneNumber", values.phoneNumber)
                            }
                          />
                          {validatePhnumber && (
                            <p className="error-message">
                              <small className="primary-color">
                                <small>
                                  <FaCheck /> {signup?.signupBox.phoneOkay}
                                </small>
                              </small>
                            </p>
                          )}
                          {errors.phoneNumber && (
                            <p className="error-message text-danger">
                              <small>{errors.phoneNumber}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="passowrd-show">
                            <input
                              id="password"
                              name="password"
                              type={values.showPassword ? "text" : "password"}
                              onChange={(e) =>
                                handleInputChange("password", e.target.value)
                              }
                              onBlur={(e) =>
                                validateField("password", e.target.value)
                              }
                              value={values.password}
                              placeholder="at least 8 characters"
                              autoComplete="false"
                            />
                            <button
                              type="button"
                              className="password-icon"
                              onClick={handleClickShowPassword}
                            >
                              {values.showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                          {errors.password && (
                            <p className="error-message text-danger">
                              <small>{errors.password}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <button
                            type="submit"
                            className="btn btn-primary hoverStroke"
                            onClick={handleSubmit}
                            disabled={loading.signUpBtn}
                          >
                            {loading.signUpBtn
                              ? processing
                              : signup?.getFundingBtn}
                          </button>
                          <p className="signupForm-info">
                            {refferalPartnerURL.signupWrapSection.p4}
                          </p>
                        </div>
                        {errors.submit && (
                          <div className="error-message error-message-gray mt-2">
                            {errors.submit}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
